<template>
  <Modal :id="'cmp-local-details-form'" @cancelled="cancel">
    <template slot="header"> {{$t('local_details')}} </template>

    <template slot="body">
      <div :class="{ 'row-container': twoColumn }" class="row">
        <div class="column dt-modal--column first-half">
          <Dropdown
            class="dt-dropdown m2"
            :options="relationTypesDropdownData"
            :selected="selectedRelationType"
            :placeholder="$t('function_1')"
            box
            :disabled="mode == 'edit'"
            v-on:selectedChange="(e) => onDropdownChange('relationType', e)"
            :listHeight="300"
          ></Dropdown>

          <div
            class="form-group"
            v-if="forms.length > 0"
            :class="{ 'two-col': twoColumn }"
          >
            <!-- :class="{
              'dt-loading shell-v2': formLoading
            }" -->
            <template v-for="form of orderedForms">
              <template v-if="form.value == 'name'" class="name">
                <TextField
                  :key="form.values"
                  class="m1"
                  :id="form.value"
                  v-bind="textFieldConfig"
                  :value="formData[form.value]"
                  :placeholder="form.text"
                  typeahead
                  :options="nameOptions"
                  @valuechanged="onFormNameChange"
                  @selected="onFormNameSelected"
                  @validated="onValidation"
                ></TextField>
              </template>
              <template v-else class="other fdd">
                <TextField
                  :key="form.values"
                  class="m1"
                  :id="form.value"
                  v-bind="textFieldConfig"
                  :value="formData[form.value]"
                  :placeholder="form.text"
                  @valuechanged="onFormTextfieldChange"
                  @validated="onValidation"
                  :height="form.value == 'notes' ? 126 : 42"
                  :textarea="form.value == 'notes' ? true : false"
                ></TextField>
              </template>
            </template>
          </div>
        </div>
        <div class="column dt-modal--column second-half">
          <div class="checkbox-container">
            <div class="dt-checkbox v2 s1">
              <input
                type="checkbox"
                @click="(e) => onSelectAll(e, 'contactRelation')"
              />
              <div class="checkmark"></div>
            </div>
            <div class="check-label">
              <span> {{$t('select_all')}} </span>
            </div>
          </div>
          <table
            class="dt-table2"
            v-if="contactRelations && contactRelations.length > 0"
          >
            <tbody class="dt-table2--body">
              <tr
                class="dt-table2--row"
                v-for="contactRelation of contactRelations"
                :key="contactRelation.contact_id"
              >
                <td class="dt-table2--column">
                  <div class="dt-checkbox v2 s1">
                    <input
                      type="checkbox"
                      @click="(e) => onCheckboxChange(e, contactRelation)"
                      :name="contactRelation.contact_id + '_selected'"
                      :id="contactRelation.contact_id + '_selected'"
                      :checked="
                        selectedContactRelations.has(contactRelation.contact_id)
                      "
                    />
                    <div class="checkmark"></div>
                  </div>
                </td>
                <td class="dt-table2--column">
                  {{ contactRelation.contact_name }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="cancel"> {{$t('cancel')}} </button>
      <button
        :disabled="!validateFormData(formData)"
        :class="{
          disabled: !validateFormData(formData),
        }"
        class="dt-button v1 s6"
        @click="submitLocalDetails"
      >
        <template v-if="mode === 'add'"> {{$t('add')}} </template>
        <template v-if="mode === 'edit'"> {{$t('save')}} </template>
      </button>
    </template>
  </Modal>
</template>

<script>
import * as R from "ramda";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { BookingService } from "../../services/booking-service";
import { capitalizeFirst } from "../../../../utility";
import {
  hotelDataToOptions,
  getHotelFromRes,
  getPhotoURL,
  validateFormData,
  getFormsArray,
  localDetailsCustomData,
} from "../../models/local-details.model";
import Modal from "../../../../dt-plugins/modal/modal";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import { find, propEq, propOr, pick, map, prop, pipe } from "ramda";

export default {
  components: {
    Modal,
  },
  props: {
    contactRelations: {
      type: Array,
    },
    relationTypes: {
      type: Array,
    },
    calendarDateId: {
      required: true,
    },
    // localDetails: {
    //   type: Object
    // },
    // mode: {
    //   type: String,
    //   required: true
    // }
  },
  watch: {
    mode: {
      immediate: true,
      handler: function (newVal, oldVal) {
        this.resetData();
      },
    },
    localDetails: {
      immediate: true,
      handler: function (newVal, oldVal) {
        console.log("Log: newVal", newVal);
        if (this.validateFormData(newVal)) {
          this.formData = {
            ...newVal.formData,
          };

          this.forms = newVal.forms;
          this.selectedRelationType = newVal?.formData?.local_details_type_name
            ? {
                text: newVal.formData.local_details_type_name,
                value: newVal.formData.local_details_type_id,
              }
            : null;
          this.selectedContactRelations = new Set(
            newVal.selectedContactRelations?.map((e) => e.contact_id)
          );
          console.log(newVal, this.selectedRelationType);
        }
      },
    },
  },
  data: function () {
    return {
      selectedContactRelations: new Set(),
      selectedRelationType: undefined,
      formLoadingFlag: false,
      forms: [],
      formData: {},
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
      },
      validationResult: {},
      nameOptions: [],
      nameSubject$: new Subject(),
      photoUrl: "",
      localDetailsNames: [],
      localDetailsFormResponse: null,

      localDetails: null,
    };
  },
  mounted: function () {
    // this.nameSubject$.asObservable()
    // .debounceTime(200)
    // .subscribe(res => {
    //   console.error(res);
    // });

    try {
      if (!this.mode) {
        throw Error("Please pass a valid mode as a Query param");
      }
      console.log(this.local_detail_id);
      if (this.mode === "edit" && !this.local_detail_id) {
        throw Error("Please pass a Local Details ID if its Edit Mode");
      }
    } catch (error) {
      console.error(error.message);
      NotificationService.showNotification({
        text: error.message,
        type: "error",
      }).then();
    }

    BookingService.findLocalDetailsMore({
      calendarDateId: this.calendarDateId,
      localDetailsId: this.local_detail_id,
    }).then((res) => {
      // console.log(res, getFormsArray(res.data, 'custom_data_id'));
      // console.log(getFormsArray(res.data, 'custom_data_id'));
      this.localDetails = {
        forms: getFormsArray(res.data, "custom_data_id"),
        formData: {
          ...res.data.local_details,
          ...localDetailsCustomData(res.data.local_details_custom || []),
        },
        selectedContactRelations: res.data.local_details_contacts,
      };
    });

    this.$subscribeTo(
      this.nameSubject$
        .asObservable()
        .pipe(distinctUntilChanged(), debounceTime(1000)),
      (name) => {
        console.error("nameSub", name);

        console.log(this.selectedRelationType, this.relationTypes);

        const selectdRelType = this.relationTypes.find(
          (e) => e.local_details_type_name === this.selectedRelationType.text
        );

        console.log(selectdRelType);

        let googlePlaceReq;

        if (selectdRelType.local_details_type_name === "Hotel") {
          googlePlaceReq = {
            calendarDateId: this.calendarDateId,
            term: name,
          };
        } else if (selectdRelType.local_details_type_name === "Restaurant") {
          googlePlaceReq = {
            calendarDateId: this.calendarDateId,
            term: name,
            searchTypeParam: "restaurant",
          };
        }

        if (googlePlaceReq) {
          BookingService.findGooglePlaces(googlePlaceReq).then((res) => {
            this.nameOptions = hotelDataToOptions(res);
            // console.log(this.nameOptions);
          });
        } else {
          BookingService.findLocalDetailsName({
            calendarDateId: this.calendarDateId,
            term: name,
          }).then((res) => {
            console.log(res);
            this.localDetailsNames = res.data;
            this.nameOptions = res.data.map((e) => ({
              text: e.name,
              value: e.id,
            }));
          });
        }
      }
    );
  },
  computed: {
    relationTypesDropdownData: function () {
      return this.relationTypes.map((e) => ({
        text: e.local_details_type_name,
        value: e.local_details_type_id,
      }));
    },
    formLoading: function () {
      return this.formLoadingFlag;
    },
    mode: function () {
      return this.$route.query && this.$route.query.mode;
    },
    local_detail_id: function () {
      return this.$route.query.local_detail_id;
    },
    twoColumn: function () {
      console.log("Total Col ", this.forms?.length);
      return this.forms?.length == 14;
    },
    orderedForms() {
      return this.forms?.length > 0
        ? [
            ...this.forms.filter((e) => e.value != "notes"),
            this.forms.find((e) => e.value == "notes"),
          ].filter((e) => e)
        : [];
    },
  },
  methods: {
    onSelectNone: function (event) {
      this.selectedContactRelations = new Set();
    },
    onSelectAll: function (event) {
      this.selectedContactRelations = new Set(
        this.contactRelations.map((e) => e.contact_id)
      );
    },
    onDropdownChange: function (name, event) {
      if (name === "relationType") {
        this.resetData();
        this.selectedRelationType = event;

        this.formLoadingFlag = true;
        BookingService.findLocalDetailsForm(
          this.selectedRelationType.value,
          this.calendarDateId
        ).then((res) => {
          this.localDetailsFormResponse = res.data;
          this.forms = [
            ...res.data.local_details_elements
              .split(",")
              .map(fromLocalDetailsElements),
            ...res.data.local_details_custom.map(mapCustomField),
          ];
          this.formLoadingFlag = false;
          this.$emit("show_column", this.twoColumn);
        });
      }
    },
    resetData: function () {
      this.selectedContactRelations = new Set();
      this.formLoadingFlag = false;
      this.forms = [];
      this.formData = {};
      this.validationResult = {};
      this.nameOptions = [];
      this.photoUrl = "";
      this.fromLocalDetailsElements = null;
      this.selectedRelationType = null;
    },
    resetAllData: function () {
      this.resetData();
      // Additional Component Data to be reset
    },
    onFormTextfieldChange: function (name, event) {
      console.log(name, event);
      this.$set(this.formData, name, event);
    },
    onFormNameChange: function (name, event) {
      this.$set(this.formData, name, event);
      this.nameSubject$.next(event);
    },
    onFormNameSelected: function (option) {
      // console.log(option);
      this.$set(this.formData, "name", option.text);
      // console.log(this.formData);

      if (["Hotel", "Restaurant"].includes(this.selectedRelationType.text)) {
        BookingService.findHotelDetails({
          calendarDateId: this.calendarDateId,
          placeId: option.value,
        }).then((res) => {
          const hotelData = getHotelFromRes(res);

          Object.keys(hotelData)
            .filter((key) => this.forms.map((e) => e.value).includes(key))
            .map((key) => {
              this.$set(this.formData, key, hotelData[key]);
            });
          console.log(this.forms, this.formData);
          this.photoUrl = getPhotoURL(res);
        });
      } else {
        const findLocalDetailsName = find(
          propEq("id", propOr("", "value", option))
        );
        const refinedLocalDetails = pick(map(prop("value"), this.forms));

        const getRefinedLocalDetails = pipe(
          findLocalDetailsName,
          refinedLocalDetails
        );

        console.log(getRefinedLocalDetails(this.localDetailsNames));
        this.formData = {
          ...this.formData,
          ...getRefinedLocalDetails(this.localDetailsNames),
        };
      }
    },
    onCheckboxChange: function (event, contactRelation) {
      if (event.target.checked) {
        if (!this.selectedContactRelations.has(contactRelation.contact_id)) {
          this.selectedContactRelations.add(contactRelation.contact_id);
        }
      } else {
        if (this.selectedContactRelations.has(contactRelation.contact_id)) {
          this.selectedContactRelations.delete(contactRelation.contact_id);
        }
      }
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    cancel: function (event) {
      this.$emit("cancelled", true);
    },
    submitLocalDetails: function (event) {
      this.formLoadingFlag = true;
      if (this.mode === "add") {
        this.$emit("submit_local_details", {
          mode: this.mode,
          calendarDateId: this.calendarDateId,
          localDetailsTypeId: this.selectedRelationType.value,
          localDetailsFormData: this.formData,
          selectedContactRelations: Array.from(this.selectedContactRelations),
        });
      } else if (this.mode === "edit") {
        this.$emit("submit_local_details", {
          mode: this.mode,
          localDetailsId: this.formData.local_detail_id,
          localDetailsFormData: this.formData,
          selectedContactRelations: Array.from(this.selectedContactRelations),
        });
      }
      // this.resetData();
    },
    validateFormData: function (data) {
      if (this.mode == "edit") {
        return data && Object.values(data).filter((e) => Boolean(e)).length > 0;
      }
      return data && this.selectedRelationType?.value;
    },
  },
};

const mapCustomField = (e) => ({
  text: e.field_label,
  value: e.custom_field_id,
});

const fromLocalDetailsElements = (e) => ({
  text: capitalizeFirst(e),
  value: e,
});
</script>

<style lang="scss">
.cmp-local-details-form {
  .first-half {
    height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .checkbox-container {
    display: flex;
    .dt-checkbox {
      margin: 5px 0 0 21px;
    }
    .check-label {
      margin-left: 10px;
    }
  }
  .dt-table2 {
    .dt-table2--column:nth-child(1) {
      flex: 0.1;
      max-width: 27px;
      padding-right: 5px;
    }
  }

  .two-col {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    padding: 6px 1px;
    position: relative;
    > .box {
      width: 50%;
      &:nth-of-type(odd) {
        padding-right: 6px;
      }
      &:nth-of-type(even) {
        padding-left: 6px;
      }
    }
  }
  .row-container {
    .column {
      width: 100%;
      &.first-half {
        flex: 66.666667% !important;
        max-width: 66.666667%;
      }
    }
  }

  .row {
    display: flex;
    flex-wrap: wrap;

    .column {
      flex: 1;
    }
  }
}

// .form-flex-container {
//   padding-right: 5px;
// }
// .cr-flex-container {
//   padding-left: 5px;
// }

// .form-container {
//   height: 600px;
//   overflow: auto;
// }

// .ld-form-row {
//   margin: 10px 5px;
// }

// .form-label {
//   text-align: right;
//   padding: 2px 10px;
// }
// .select-cr {
//   padding-top: 5px;
//   padding-left: 10px;
// }

// .photo-space {
//   flex: 2;
// }

// .photo-row {
//   position: absolute;
//   bottom: 20px;
// }
</style>
